module.exports = __webpack_public_path__ + "media/components/weather-icon/static/nightpartcloud@2-30cd70de0e2305f5892437439b139bba.png";